import { BellIcon, ChartBarIcon, ChatBubbleOvalLeftIcon, ClipboardDocumentIcon, CogIcon, HomeIcon, TableCellsIcon, UserPlusIcon } from "@heroicons/react/24/solid";
import React from "react";
import { Link } from "react-router-dom";

export default function AdminTopNav() {
  const navStyle = "flex items-center justify-center flex-col py-1 text-gray-600 hover:text-gray-900 text-xs w-[80px]";
  const iconStyles = "block w-5 h-5 mb-1"

  return (
    <div className="z-10 fixed top-0 left-0 h-[60px] w-full bg-white border-b border-b-gray-300 px-4 py-1 flex justify-between">
      <ul className="flex items-center">
        <Link className={navStyle} to="/">
          <HomeIcon className={iconStyles} />
          <span className="block">Home</span>
        </Link>
        <Link className={navStyle} to="/analytics">
          <ChartBarIcon className={iconStyles} />
          <span className="block">Analytics</span>
        </Link>
        <Link className={navStyle} to="/notifications">
          <BellIcon className={iconStyles} />
          <span className="block">Notifications</span>
        </Link>
        <Link className={navStyle} to="/support">
          <ChatBubbleOvalLeftIcon className={iconStyles} />
          <span className="block">Support</span>
        </Link>
        <Link className={navStyle} to="/recruiters">
          <TableCellsIcon className={iconStyles} />
          <span className="block">Recruiters</span>
        </Link>
        <Link className={navStyle} to="/clients">
          <TableCellsIcon className={iconStyles} />
          <span className="block">Clients</span>
        </Link>
        <Link className={navStyle} to="/orders">
          <TableCellsIcon className={iconStyles} />
          <span className="block">Orders</span>
        </Link>
      </ul>
      <ul className="flex items-center">
        <Link className={navStyle} to="/create-order">
          <ClipboardDocumentIcon className={iconStyles} />
          <span className="block">New Order</span>
        </Link>
        <Link className={navStyle} to="/create-client">
          <UserPlusIcon className={iconStyles} />
          <span className="block">New Client</span>
        </Link>
        <Link className={navStyle} to="/settings">
          <CogIcon className={iconStyles} />
          <span className="block">Settings</span>
        </Link>
      </ul>
    </div>
  );
}
